import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordinalDate'
})
export class OrdinalDatePipe implements PipeTransform {
  transform(value: Date): string {
    if (!new Date(value)) {
      return '';
    }
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = new Date(value).getFullYear();
    const date = new Date(value).getDate();
    const ordinal = this.nth(date);
    return `${date}<sup><small>${ordinal}</small></sup> ${months[new Date(value).getMonth()]} ${year % 100}`;
  }
  

 nth(d: any) {
  if (d > 3 && d < 21) return 'th'; 
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}
}